import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LayoutSplashScreen } from 'src/app/layout';
import { FormMode, RulesType } from 'src/app/modules/PulseLeads/types/auto-lead-reassignment-types';
import RulesDetailForm from './components/RulesDetailForm';
import { NOT_FOUND_ERROR_PAGE_PATH } from '@pruforce/common-adminweb-sdk';
import { fetchItem } from 'src/app/modules/PulseLeads/network/autoLeadReassignmentCrud';

interface StateType {
  type: FormMode;
}

const RulesDetailPage: FC<RouteComponentProps & { ruleType: RulesType }> = ({ history, location, ruleType }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode, itemId } = useMemo(() => {
    const state = (location.state ? location.state : { type: FormMode.CREATE }) as StateType;
    return {
      formMode: state.type,
      itemId: id ? id : undefined,
    };
  }, [id, location]);

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [itemDetail, setItemDetail] = useState<any>();

  const reloadData = () => {
    if (itemId) {
      setIsLoading(true);
      fetchItem(ruleType, itemId, dispatch)
        .then((result) => {
          setItemDetail({ ...result, id: itemId });
        })
        .catch(() => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [itemId]);

  return (
    <>
      {formMode === FormMode.CREATE && (
        <RulesDetailForm ruleType={ruleType} formMode={formMode} onReload={reloadData} onRouteTo={(route) => history.push(route)} />
      )}
      {formMode !== FormMode.CREATE &&
        (isLoading || !itemDetail ? (
          <LayoutSplashScreen />
        ) : (
          <RulesDetailForm
            ruleType={ruleType}
            itemId={itemId}
            formMode={formMode}
            itemDetail={itemDetail}
            onReload={reloadData}
            onRouteTo={(route) => history.push(route)}
          />
        ))}
    </>
  );
};

export default RulesDetailPage;
